import { getNotificationLogger } from './log';
import { userContractId } from '../util';

const log = getNotificationLogger('service');

const currentUserContractId = userContractId();

export function getContext(): NotificationContext {
    const ctx = loadConfig();
    if (ctx.token && !ctx.contractId && currentUserContractId) {
        ctx.contractId = currentUserContractId;
        store(ctx);
    }
    return ctx;
}

export function reset() {
    log('reset');
    store({});
}

export function storeToken(token) {
    log('storeToken', token);
    if (token) {
        const ctx = getContext();
        ctx.token = token;
        if (currentUserContractId) {
            ctx.contractId = currentUserContractId;
        }
        store(ctx);
    }
}

function loadConfig(): NotificationContext {
    log('loadConfig');
    let loaded = JSON.parse(localStorage.getItem('notifications.config')) || {};
    return { contractId: loaded.contractId, token: loaded.token };
}

function store(ctx?: NotificationContext | {}) {
    log('store', ctx);
    localStorage.setItem('notifications.config', JSON.stringify(ctx));
}

type NotificationContext = { contractId: string; token: string };
